import { COMPANY, INDIVIDUAL } from '@constants/customerTypes'
import { CountriesType } from '@services/payments/useGetCountries'
import {
  CUSTOMER_COMPANY_TYPE,
  CUSTOMER_INDIVIDUAL_TYPE,
  CustomerTypes,
  GetCustomerResourceResponse
} from '@services/payments/useGetCustomerResource'

export const getMappedCountries = (countries: CountriesType[]) =>
  countries.map(({ iso, name }) => ({
    value: iso,
    label: name
  }))

export const getFilteredCountries = ({
  countries,
  searchPhrase
}: {
  countries: CountriesType[]
  searchPhrase: string
}) =>
  countries.filter(({ name }) =>
    name.toLowerCase().includes(searchPhrase.toLowerCase())
  )

export const isEuropeanUnion = ({
  countries,
  country
}: {
  countries: CountriesType[]
  country: string
}) => countries.find(({ iso }) => iso === country)?.is_european_union

export const isCustomerDataFilled = (
  customerResourceData: GetCustomerResourceResponse
) => {
  const { name, street, city, postal_code, country } = customerResourceData

  return (
    Boolean(name?.trim()) &&
    Boolean(street?.trim()) &&
    Boolean(city?.trim()) &&
    Boolean(postal_code?.trim()) &&
    Boolean(country?.trim())
  )
}

export const isCompanyCustomer = (isCompany: CustomerTypes) =>
  isCompany === CUSTOMER_COMPANY_TYPE

export const getCustomerType = (customer?: CustomerTypes) => {
  switch (customer) {
    case CUSTOMER_COMPANY_TYPE:
      return COMPANY
    case CUSTOMER_INDIVIDUAL_TYPE:
      return INDIVIDUAL
    default:
      return COMPANY
  }
}

export const getCountryLabel = ({
  countries,
  country
}: {
  countries: CountriesType[]
  country: string
}) => countries.find(({ iso }) => iso === country)?.name || ''

export const getVATLabel = (country: string) =>
  country === 'PL'
    ? 'registration.flow.credit.card.step.vat.pl'
    : 'registration.flow.credit.card.step.vat'

export const getVATTooltip = (country: string) =>
  country === 'PL'
    ? 'creditcardstep.form.vat.tooltip.pl'
    : 'creditcardstep.form.vat.tooltip'
